import React from "react";
import { PageShell } from "../components/Layout";
import SeoContent from "../components/SeoContent";
import { api } from "../services/api";
import { Search, Moon } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function DreamNumber() {
  const [q, setQ] = React.useState("");
  const [dreams, setDreams] = React.useState([]);
  useSeo({
    title: "Sunday Ground Teer Dream Number Chart | Dream Meaning Numbers",
    description:
      "Sunday Ground Teer Dream Number chart - find the lucky Direct, House & Ending numbers for your dream (snake, water, money and more). Search your dream instantly.",
  });

  React.useEffect(() => {
    api.dreams().then(setDreams).catch(() => setDreams([]));
  }, []);

  const list = dreams.filter((d) => d.dream.toLowerCase().includes(q.toLowerCase()));

  return (
    <>
      <PageShell title="Dream Number" subtitle="What did you see in your dream? Find your lucky number">
        <div className="max-w-md mx-auto mb-6 relative">
          <Search className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search your dream (e.g. Snake, Water, Money)"
            className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-300 outline-none focus:ring-2 focus:ring-[#e8491d]/40 focus:border-[#e8491d] text-sm"
          />
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden max-w-3xl mx-auto">
          <div className="grid grid-cols-4 bg-[#e8491d] text-white font-black text-sm sm:text-base">
            <div className="py-3 px-3 flex items-center gap-1.5">
              <Moon className="w-4 h-4" /> Dream
            </div>
            <div className="py-3 px-3 text-center">Direct</div>
            <div className="py-3 px-3 text-center">House</div>
            <div className="py-3 px-3 text-center">Ending</div>
          </div>
          {list.map((d, i) => (
            <div
              key={d.id || d.dream}
              className={`grid grid-cols-4 items-center text-sm sm:text-base border-b border-gray-100 ${
                i % 2 ? "bg-gray-50" : "bg-white"
              }`}
            >
              <div className="py-3 px-3 font-bold text-[#1f2733]">{d.dream}</div>
              <div className="py-3 px-3 text-center font-black text-[#e8491d]">{d.direct}</div>
              <div className="py-3 px-3 text-center font-black text-[#1aa79a]">{d.house}</div>
              <div className="py-3 px-3 text-center font-black text-[#1aa79a]">{d.ending}</div>
            </div>
          ))}
          {list.length === 0 && (
            <div className="py-8 text-center text-gray-400 text-sm">No dream found for "{q}"</div>
          )}
        </div>
      </PageShell>
      <SeoContent variant="dream" />
    </>
  );
}
